// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__KIW2p","header":"ReportDetails_header__3ud2X","title":"ReportDetails_title__1K_D7","left":"ReportDetails_left__2Fbmv"};